import React from 'react';
import { IConversationOptions } from 'src/types/serviceResponseTypes';
import LatexHTMLRenderer from 'src/app/components/LatexHTMLRenderer/LatexHTMLRenderer';

type ChoiceLabelPropType = {
  choice: IConversationOptions;
  className?: string;
};

function ChoiceLabel(props: ChoiceLabelPropType) {
  const { choice, className = '' } = props;

  return (
    <div className={`mx-space-3 flex items-center text-body-small ${className}`} tabIndex={-1}>
      <span className="flex">{`${choice.key}`}<span aria-hidden="true">.</span></span>
      <span className="px-space-2 w-full">
        <LatexHTMLRenderer content={choice.text} className={className} size='small' />
      </span>
    </div>
  );
}

export default React.memo(
  ChoiceLabel,
  (pp, np) => JSON.stringify({choice: pp.choice, className: pp.className}) 
  === JSON.stringify({choice: np.choice, className: np.className})
);
